import React from "react";
import WebAssetRoundedIcon from "@mui/icons-material/WebAssetRounded";
import Grid from "@mui/material/Grid";

export const AccordianHeader = () => {
  return (
    <Grid container direction="row" justifyContent="center" alignItems="center" spacing={3}>
      <Grid container justifyContent="center" alignItems="center" item sm={1} xs={2}>
        <WebAssetRoundedIcon data-testid="header-icon" aria-label="Accordion Header Icon" />
      </Grid>
      <Grid item sm={11} xs={10}>
        <h3>For completion by office</h3>
      </Grid>
    </Grid>
  );
};
